<template>
  <Drawer id="sidemenu" ref="sidemenu">
    <template #button>
      <IconBurger />
    </template>
    <template #default
    >
      <div class="bg-theme-primary w-[350px] h-screen overflow-y-auto">
        <div
          class="bg-theme-primary text-theme-font p-2 m-0 min-h-screen flex flex-col gap-1"
        >
          <div class="flex-none flex mt-0.5 items-center">
            <IconLogo class="h-[45px]" :dark="true" />
            <div class="flex-none flex items-center px-1">
              <h1 class="font-semibold text-[1.3125rem] visible">{{ platformName }}</h1>
            </div>
          </div>
          <ul class="flex flex-none flex-col gap-[25px] mt-2 mb-2">
            <li>
              <NuxtLink @click="closeMenu()" to="/"
              ><span class="menu-element">{{ $t('navigation.home') }}</span></NuxtLink
              >
            </li>
            <li>
              <NuxtLink @click="closeMenu()" to="/spots"
              ><span class="menu-element">{{ $t('navigation.spots') }}</span></NuxtLink
              >
            </li>
            <li>
              <NuxtLink @click="closeMenu()" to="/map">
                <span class="menu-element">{{ $t('navigation.map') }}</span>
              </NuxtLink>
            </li>
            <li v-if="loggedIn && user?.premium">
              <NuxtLink @click="closeMenu()" to="/premium">
                <span class="menu-element">{{ $t('navigation.premium') }}</span>
              </NuxtLink>
            </li>
            <li v-if="loggedIn">
              <NuxtLink @click="closeMenu()" to="/profile"
              ><span class="menu-element">{{ $t('navigation.profile') }}</span></NuxtLink
              >
            </li>
            <li v-if="loggedIn">
              <NuxtLink @click="closeMenu()" to="/settings"
              ><span class="menu-element">{{ $t('navigation.settings') }}</span></NuxtLink
              >
            </li>
            <li v-if="!loggedIn">
              <a href="/auth/keycloak">
                <span class="menu-element">{{ $t('navigation.login') }}</span>
              </a>
            </li>
            <li v-if="loggedIn">
              <button @click="logout()">
                <span class="menu-element">{{ $t('navigation.logout') }}</span>
              </button>
            </li>
          </ul>
          <ul class="flex flex-none flex-col gap-1">
            <li v-if="loggedIn">
              <button @click="openOnboardingModal()"
              ><span>Onboarding</span></button
              >
            </li>
            <li>
              <NuxtLink @click="closeMenu()" to="/about"
              ><span>{{ $t('navigation.about') }}</span></NuxtLink
              >
            </li>
            <li>
              <NuxtLink @click="closeMenu()" to="/partner"
              ><span>{{ $t('navigation.partner') }}</span></NuxtLink
              >
            </li>
            <li>
              <NuxtLink @click="closeMenu()" to="/news"
              ><span>{{ $t('navigation.news') }}</span></NuxtLink
              >
            </li>
          </ul>
          <div class="grow"></div>
          <div class="flex flex-none gap-2 mt-1">
            <LanguageSwitcher :dark="true" />
          </div>
          <div class="flex flex-none gap-2 mt-1">
            <CountrySwitcher :dark="true" />
          </div>
        </div>
      </div>
    </template
    >
  </Drawer>
</template>
<script setup lang="ts">

import { base64urlDecode } from 'iron-webcrypto';
import { getClientId } from '~/utils/hostHelper';

const { loggedIn, user, clear } = useUserSession();
const platformSettings = usePlatformSettings();
const platformName = platformSettings.platformName;
const i18n = useI18n();

const runtimeConfig = useRuntimeConfig();
// Get Keycloak server URL and realm
const authUrl = runtimeConfig.public.AUTH_URL as string;
const authRealm = runtimeConfig.public.AUTH_REALM as string;
const clientId = getClientId(platformSettings.platformName.value, platformSettings.countryCode.value, platformSettings.multinational.value);

// MP10-707: Adjust Link, when updating Keycloak

const sidemenu = ref();

function openOnboardingModal() {
  (document.getElementById('onboarding_modal') as HTMLFormElement).showModal();
  sidemenu.value.closeDrawer();
}

async function logout() {
  const url = window.location.origin+"/logout";
  const urlEnceodedPath = encodeURI(url);
  const logoutUrl = `${authUrl}realms/${authRealm}/protocol/openid-connect/logout?client_id=${clientId}&post_logout_redirect_uri=${urlEnceodedPath}`;
  console.log("Logging out from Keycloak with URL: " + logoutUrl);
  await clear();
  await navigateTo(logoutUrl, { external: true });
}

function closeMenu() {
  sidemenu.value.closeDrawer();
}
</script>
<style lang="postcss" scoped>
.router-link-active > .menu-element {
  @apply underline underline-offset-8 decoration-4 bg-none;
}

.menu-element {
  @apply text-4xl leading-6 font-bold;
}

a p {
  @apply leading-4;
}

a:hover,
button:hover {
  @apply bg-transparent text-theme-secondary;
}

</style>
